/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import each from 'lodash/each';
import Vue from 'vue';
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import AwsS3 from '@uppy/aws-s3';

function setupUploaderField(el) {
  const entryEl = el.querySelector('[data-vue-entry]');
  new Vue({
    el: entryEl,
    template: `
      <div>
        <input
          v-if="formFieldName"
          type="hidden"
          :name="formFieldName"
          :value="valueAsJson"
        />
        <div class="callout warning" v-if="valueArray.length" style="font-size: 14px">
          <small>Files uploaded:</small>
          <ul>
            <li v-for="(val, idx) in valueArray" :key="idx">{{ val }}</li>
          </ul>
        </div>
        <div v-show="shouldShowUploader" ref="uppy"></div>
      </div>
    `,
    data: {
      formFieldName: null,
      value: null,
      allowMultiple: false,
      minNumFiles: 0,
      maxNumFiles: null,
      allowedTypes: null,
      paramsUrl: null,
    },
    computed: {
      valueArray() {
        if (Array.isArray(this.value)) {
          return this.value;
        }
        if (this.value) {
          return [this.value];
        }
        return [];
      },
      valueAsJson() {
        return JSON.stringify(this.valueArray);
      },
      shouldShowUploader() {
        if (!this.allowMultiple && this.valueArray.length > 0) {
          return false;
        }
        return true;
      },
    },
    beforeMount() {
      this.formFieldName = JSON.parse(this.$el.getAttribute('data-form-field-name'));
      this.value = JSON.parse(this.$el.getAttribute('data-value'));
      console.log(this.$el.getAttribute('data-value'), this.value);
      this.allowMultiple = JSON.parse(this.$el.getAttribute('data-allow-multiple'));
      this.minNumFiles = JSON.parse(this.$el.getAttribute('data-min-num-files'));
      this.maxNumFiles = JSON.parse(this.$el.getAttribute('data-max-num-files'));
      this.allowedTypes = JSON.parse(this.$el.getAttribute('data-allowed-types'));
      this.paramsUrl = this.$el.getAttribute('data-params-url');
    },
    mounted() {
      this.$nextTick(() => {
        const { paramsUrl } = this;
        const browseText = this.allowMultiple
          ? 'Drop files here, paste, or %{browse}'
          : 'Drop file here, paste, or %{browse}';

        const uppy = Uppy({
          debug: true,
          autoProceed: false,
          allowMultipleUploads: this.maxNumFiles !== 1,
          restrictions: {
            // bytes = {X}MB * 1E+6;  1E+6 === 1,000,000
            maxFileSize: 50 * 1000000,
            maxNumberOfFiles: 1,
            minNumberOfFiles: this.minNumFiles,
            allowedFileTypes: this.allowedTypes,
          },
        })
          .use(Dashboard, {
            target: this.$refs.uppy,
            inline: true,
            replaceTargetContent: true,
            hideUploadButton: true,
            showProgressDetails: true,
            showLinkToFileUploadResult: false,
            proudlyDisplayPoweredByUppy: false,
            disableInformer: false,
            height: this.allowMultiple ? 470 : 320,
            locale: {
              strings: {
                dropPaste: browseText,
              },
            },
          })
          .use(AwsS3, {
            getUploadParameters(file) {
              return fetch(paramsUrl, {
                method: 'post',
                headers: {
                  accept: 'application/json',
                  'content-type': 'application/json',
                },
                body: JSON.stringify({
                  filename: file.name,
                  contentType: file.type,
                }),
              })
                .then(response => response.json())
                .then((data) => {
                  if ('error' in data) {
                    alert(data.error);
                    return false;
                  }
                  return {
                    method: data.method,
                    url: data.url,
                    fields: data.fields,
                  };
                });
            },
          });

        uppy.on('upload-success', (file) => {
          let values = this.valueArray.slice();
          if (!this.allowMultiple) {
            values = [file.meta.filename];
          } else {
            values.push(file.meta.filename);
          }
          this.value = values;
        });

        const $form = $(this.$el).closest('form');
        if ($form.length) {
          const uploaders = $form.data('uploaders') || [];
          uploaders.push(uppy);
          $form.data('uploaders', uploaders);
        }
      });
    },
  });
}

function setupUploaderFields(container) {
  if (!container) {
    return;
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll('.js-uppy-uploader-field');
  if (existingEls.length) {
    each(existingEls, (el) => {
      setupUploaderField(el);
    });
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return;
        }

        const els = node.querySelectorAll('.js-uppy-uploader-field');
        if (!els.length) {
          return;
        }

        each(els, (el) => {
          setupUploaderField(el);
        });
      });
    });
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });
}

export { setupUploaderFields, setupUploaderField };

